var _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignSpeedLimitAdvisoryKmhNarCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_advisory_x5F_kmh_x5F_nar_x5F_can_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_advisory_x5F_kmh_x5F_nar_x5F_can"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E2B236"
    },
    d: "M10,6h76c2.209,0,4,1.791,4,4v76c0,2.209-1.791,4-4,4H10 c-2.209,0-4-1.791-4-4V10C6,7.791,7.791,6,10,6z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86,10v76H10V10H86 M86,8H10c-1.105,0-2,0.895-2,2v76c0,1.105,0.895,2,2,2h76c1.105,0,2-0.895,2-2V10 C88,8.895,87.104,8,86,8L86,8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48,15.618c14.272,0,25.882,11.611,25.882,25.882S62.272,67.382,48,67.382S22.118,55.772,22.118,41.5 S33.728,15.618,48,15.618 M48,14c-15.188,0-27.5,12.312-27.5,27.5S32.812,69,48,69s27.5-12.312,27.5-27.5S63.188,14,48,14L48,14z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.506,73.5h1.428v5.1l2.28-2.604h1.56l-2.172,2.508l2.172,3.54h-1.596l-1.536-2.46l-0.708,0.805v1.655h-1.428V73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.65,75.996h1.368v0.744c0.112-0.271,0.3-0.48,0.564-0.625c0.264-0.143,0.6-0.215,1.008-0.215 c0.472,0,0.854,0.08,1.146,0.24s0.506,0.392,0.642,0.695c0.128-0.304,0.342-0.535,0.642-0.695c0.3-0.16,0.67-0.24,1.11-0.24 c0.72,0,1.238,0.188,1.554,0.563c0.316,0.376,0.474,0.916,0.474,1.62v3.96h-1.44v-3.636c0-0.488-0.076-0.82-0.228-0.996 s-0.42-0.264-0.804-0.264c-0.384,0-0.656,0.084-0.816,0.252c-0.16,0.168-0.244,0.476-0.252,0.924v3.72h-1.44v-3.636 c0-0.488-0.076-0.82-0.228-0.996s-0.42-0.264-0.804-0.264c-0.384,0-0.656,0.084-0.816,0.252c-0.16,0.168-0.244,0.476-0.252,0.924 v3.72H40.65V75.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.233,73.5h1.116l-3.96,8.544h-1.116L54.233,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.586,73.5h1.428v3.096c0.256-0.464,0.76-0.695,1.513-0.695c0.72,0,1.237,0.188,1.554,0.563 c0.315,0.376,0.474,0.916,0.474,1.62v3.96h-1.439v-3.636c0-0.488-0.076-0.82-0.229-0.996s-0.42-0.264-0.804-0.264 c-0.393,0-0.668,0.088-0.828,0.264s-0.24,0.508-0.24,0.996v3.636h-1.428V73.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignSpeedLimitAdvisoryKmhNarCan);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_speed_limit_advisory_kmh_nar_can.2fc3aaee0abe98c4f7132e11a1a6d5f5.svg";
export { ForwardRef as ReactComponent };